import fs from './fetchsaga'

export default [
	fs,
]


// WEBPACK FOOTER //
// ./src/redux/sagas/index.js